
import { concat, isNullOrWhiteSpace, join } from "../fable_modules/fable-library-js.5.3.0/String.js";
import { ofArray, filter } from "../fable_modules/fable-library-js.5.3.0/List.js";

/**
 * Combines multiple Tailwind class name strings into a single space-separated class string
 */
export function tw(classes) {
    return join(" ", filter((arg) => !isNullOrWhiteSpace(arg), classes));
}

export function hover(cls) {
    return concat("hover:", cls);
}

export function focus(cls) {
    return concat("focus:", cls);
}

export function focusVisible(cls) {
    return concat("focus-visible:", cls);
}

/**
 * Apply a class when any descendant matches :focus-visible (Tailwind has-[...] selector)
 */
export function hasFocusVisible(cls) {
    return concat("has-[:focus-visible]:", cls);
}

/**
 * Apply a class when a preceding sibling marked with the "peer" class matches :focus-visible
 */
export function peerFocusVisible(cls) {
    return concat("peer-focus-visible:", cls);
}

export function active(cls) {
    return concat("active:", cls);
}

export function dark(cls) {
    return concat("dark:", cls);
}

export function sm(cls) {
    return concat("sm:", cls);
}

export function md(cls) {
    return concat("md:", cls);
}

export function lg(cls) {
    return concat("lg:", cls);
}

export function xl(cls) {
    return concat("xl:", cls);
}

export const backgroundColor_bgPrimary50 = "bg-primary-50";

export const backgroundColor_bgPrimary100 = "bg-primary-100";

export const backgroundColor_bgPrimary500 = "bg-primary-500";

export const backgroundColor_bgPrimary600 = "bg-primary-600";

export const backgroundColor_bgPrimary700 = "bg-primary-700";

export const backgroundColor_bgSecondary50 = "bg-secondary-50";

export const backgroundColor_bgSecondary100 = "bg-secondary-100";

export const backgroundColor_bgSecondary600 = "bg-secondary-600";

export const backgroundColor_bgSecondary700 = "bg-secondary-700";

export const backgroundColor_bgNeutral50 = "bg-neutral-50";

export const backgroundColor_bgNeutral100 = "bg-neutral-100";

export const backgroundColor_bgNeutral200 = "bg-neutral-200";

export const backgroundColor_bgNeutral300 = "bg-neutral-300";

export const backgroundColor_bgNeutral400 = "bg-neutral-400";

export const backgroundColor_bgNeutral800 = "bg-neutral-800";

export const backgroundColor_bgDanger50 = "bg-danger-50";

export const backgroundColor_bgDanger100 = "bg-danger-100";

export const backgroundColor_bgDanger600 = "bg-danger-600";

export const backgroundColor_bgDanger700 = "bg-danger-700";

export const backgroundColor_bgSuccess50 = "bg-success-50";

export const backgroundColor_bgSuccess100 = "bg-success-100";

export const backgroundColor_bgSuccess200 = "bg-success-200";

export const backgroundColor_bgSuccess600 = "bg-success-600";

export const backgroundColor_bgSuccess700 = "bg-success-700";

export const backgroundColor_bgWarning50 = "bg-warning-50";

export const backgroundColor_bgWarning100 = "bg-warning-100";

export const backgroundColor_bgInfo50 = "bg-info-50";

export const backgroundColor_bgInfo100 = "bg-info-100";

export const backgroundColor_bgStatusDraftBg = "bg-status-draft-bg";

export const backgroundColor_bgStatusPlannedBg = "bg-status-planned-bg";

export const backgroundColor_bgStatusPublishedBg = "bg-status-published-bg";

export const backgroundColor_bgStatusPublishedAction = "bg-status-published-action";

export const backgroundColor_bgStatusPublishedActionHover = "bg-status-published-action-hover";

export const backgroundColor_bgStatusPledgedBg = "bg-status-pledged-bg";

export const backgroundColor_bgStatusActiveBg = "bg-status-active-bg";

export const backgroundColor_bgStatusFinalizingBg = "bg-status-finalizing-bg";

export const backgroundColor_bgStatusFinalizedBg = "bg-status-finalized-bg";

export const backgroundColor_bgStatusAbandonedBg = "bg-status-abandoned-bg";

export const backgroundColor_bgSurface = "bg-surface";

export const backgroundColor_bgSurfaceElevated = "bg-surface-elevated";

export const backgroundColor_bgSurfaceInset = "bg-surface-inset";

export const textColor_textPrimary50 = "text-primary-50";

export const textColor_textPrimary600 = "text-primary-600";

export const textColor_textPrimary700 = "text-primary-700";

export const textColor_textPrimary800 = "text-primary-800";

export const textColor_textPrimary900 = "text-primary-900";

export const textColor_textOnPrimary = "text-on-primary";

export const textColor_textSecondary600 = "text-secondary-600";

export const textColor_textSecondary800 = "text-secondary-800";

export const textColor_textNeutral100 = "text-neutral-100";

export const textColor_textNeutral400 = "text-neutral-400";

export const textColor_textNeutral500 = "text-neutral-500";

export const textColor_textNeutral600 = "text-neutral-600";

export const textColor_textNeutral700 = "text-neutral-700";

export const textColor_textNeutral800 = "text-neutral-800";

export const textColor_textNeutral900 = "text-neutral-900";

export const textColor_textDanger400 = "text-danger-400";

export const textColor_textDanger600 = "text-danger-600";

export const textColor_textDanger700 = "text-danger-700";

export const textColor_textDanger800 = "text-danger-800";

export const textColor_textDanger900 = "text-danger-900";

export const textColor_textOnDanger = "text-on-danger";

export const textColor_textSuccess500 = "text-success-500";

export const textColor_textSuccess600 = "text-success-600";

export const textColor_textSuccess700 = "text-success-700";

export const textColor_textSuccess800 = "text-success-800";

export const textColor_textWarning700 = "text-warning-700";

export const textColor_textWarning800 = "text-warning-800";

export const textColor_textWarning900 = "text-warning-900";

export const textColor_textInfo500 = "text-info-500";

export const textColor_textInfo600 = "text-info-600";

export const textColor_textInfo700 = "text-info-700";

export const textColor_textStatusDraftText = "text-status-draft-text";

export const textColor_textStatusPlannedText = "text-status-planned-text";

export const textColor_textStatusPublishedText = "text-status-published-text";

export const textColor_textStatusPledgedText = "text-status-pledged-text";

export const textColor_textStatusActiveText = "text-status-active-text";

export const textColor_textStatusFinalizingText = "text-status-finalizing-text";

export const textColor_textStatusFinalizedText = "text-status-finalized-text";

export const textColor_textStatusAbandonedText = "text-status-abandoned-text";

export const borderColor_borderPrimary200 = "border-primary-200";

export const borderColor_borderPrimary300 = "border-primary-300";

export const borderColor_borderPrimary400 = "border-primary-400";

export const borderColor_borderPrimary500 = "border-primary-500";

export const borderColor_borderPrimary600 = "border-primary-600";

export const borderColor_borderSecondary500 = "border-secondary-500";

export const borderColor_borderSecondary600 = "border-secondary-600";

export const borderColor_borderNeutral100 = "border-neutral-100";

export const borderColor_borderNeutral200 = "border-neutral-200";

export const borderColor_borderNeutral300 = "border-neutral-300";

export const borderColor_borderDanger200 = "border-danger-200";

export const borderColor_borderDanger300 = "border-danger-300";

export const borderColor_borderDanger400 = "border-danger-400";

export const borderColor_borderDanger500 = "border-danger-500";

export const borderColor_borderSecondary200 = "border-secondary-200";

export const borderColor_borderWarning200 = "border-warning-200";

export const borderColor_borderWarning300 = "border-warning-300";

export const borderColor_borderSuccess200 = "border-success-200";

export const borderColor_borderInfo500 = "border-info-500";

export const borderColor_borderTTransparent = "border-t-transparent";

export const ringColor_ringPrimary300 = "ring-primary-300";

export const ringColor_ringPrimary500 = "ring-primary-500";

export const ringColor_ringSecondary300 = "ring-secondary-300";

export const ringColor_ringSecondary500 = "ring-secondary-500";

export const ringColor_ringDanger300 = "ring-danger-300";

export const ringColor_ringDanger500 = "ring-danger-500";

export const borderRadius_roundedFull = "rounded-full";

export const borderRadius_roundedBLg = "rounded-b-lg";

export const borderRadius_roundedSm = "rounded-sm";

export const borderRadius_roundedT2xl = "rounded-t-2xl";

export const outline_outlineNone = "outline-none";

export const padding_py12 = "py-12";

export const padding_py16 = "py-16";

export const padding_pr16 = "pr-16";

export const padding_py1_5 = "py-1.5";

export const maxHeight_maxHNone = "max-h-none";

export const lineClamp_lineClamp2 = "line-clamp-2";

export const minHeight_minHDvh = "min-h-dvh";

export const minHeight_minH11 = "min-h-11";

export const minHeight_minH12 = "min-h-12";

export const topPosition_top8 = "top-8";

export const gap_gap2 = "gap-2";

export const gap_gap3 = "gap-3";

export const gap_gap4 = "gap-4";

export const gap_gap8 = "gap-8";

export const grid_gridCols2 = "grid-cols-2";

export const grid_gridCols1fr280px = "grid-cols-[1fr_280px]";

export const grid_gridCols1fr320px = "grid-cols-[1fr_320px]";

export const space_spaceX4 = "space-x-4";

export const space_spaceX6 = "space-x-6";

export const space_spaceY0 = "space-y-0";

export const space_spaceY1 = "space-y-1";

export const space_spaceY2 = "space-y-2";

export const space_spaceY3 = "space-y-3";

export const space_spaceY4 = "space-y-4";

export const space_spaceY6 = "space-y-6";

export const transform_transform = "transform";

export const ring_ring0 = "ring-0";

export const ring_ring1 = "ring-1";

export const ring_ring2 = "ring-2";

export const ring_ringBlack5 = "ring-black/5";

export const ringOffsetWidth_ringOffset0 = "ring-offset-0";

export const ringOffsetWidth_ringOffset1 = "ring-offset-1";

export const ringOffsetWidth_ringOffset2 = "ring-offset-2";

export const animation_animateNone = "animate-none";

export const animation_animateSpin = "animate-spin";

export const animation_animatePing = "animate-ping";

export const animation_animatePulse = "animate-pulse";

export const animation_animateBounce = "animate-bounce";

export const animation_animateFadeOut = "animate-fade-out";

export const animation_animateShimmer = "animate-shimmer";

export const gradientColorStops_fromPrimary500 = "from-primary-500";

export const gradientColorStops_toSecondary600 = "to-secondary-600";

export const FocusVisible_ringWidth1 = ring_ring1;

export const FocusVisible_ringWidth2 = ring_ring2;

export const FocusVisible_ring = tw(ofArray([focusVisible(outline_outlineNone), focusVisible(FocusVisible_ringWidth2), focusVisible(ringColor_ringPrimary500), focusVisible(ringOffsetWidth_ringOffset2)]));

export const FocusVisible_ringSlim = tw(ofArray([focusVisible(outline_outlineNone), focusVisible(FocusVisible_ringWidth1), focusVisible(ringColor_ringPrimary500), focusVisible(ringOffsetWidth_ringOffset0)]));

export const FocusVisible_ringInset = tw(ofArray([focusVisible(outline_outlineNone), focusVisible(FocusVisible_ringWidth2), focusVisible(ringColor_ringPrimary500), focusVisible(ringOffsetWidth_ringOffset1)]));

export const FocusVisible_ringInsetDanger = tw(ofArray([focusVisible(outline_outlineNone), focusVisible(FocusVisible_ringWidth2), focusVisible(ringColor_ringDanger500), focusVisible(ringOffsetWidth_ringOffset1)]));

export const FocusVisible_ringDanger = tw(ofArray([focusVisible(outline_outlineNone), focusVisible(FocusVisible_ringWidth2), focusVisible(ringColor_ringDanger500), focusVisible(ringOffsetWidth_ringOffset2)]));

const HasFocusVisible_ringWidth2 = ring_ring2;

export const HasFocusVisible_ring = tw(ofArray([hasFocusVisible(outline_outlineNone), hasFocusVisible(HasFocusVisible_ringWidth2), hasFocusVisible(ringColor_ringPrimary500), hasFocusVisible(ringOffsetWidth_ringOffset2)]));

const PeerFocusVisible_ringWidth2 = ring_ring2;

export const PeerFocusVisible_ring = tw(ofArray([peerFocusVisible(outline_outlineNone), peerFocusVisible(PeerFocusVisible_ringWidth2), peerFocusVisible(ringColor_ringPrimary500), peerFocusVisible(ringOffsetWidth_ringOffset2)]));

//# sourceMappingURL=TailwindExtensions.js.map
